<template>
    <main class="h-screen w-screen">
        <navbar-simple />
        <div id="onboarding-container" class="container mx-auto pt-6">
            <div class="w-full h-20"></div>
            <steps-viewer
                v-if="currentStep !== -1"
                :steps="$data.$steps"
                :step="currentStep"
            />
            <router-view />
            <div class="w-full h-20"></div>

            <div class="z-40 p-2 border-top border-left border-theme-success">
                <change-theme />
            </div>
        </div>
    </main>
</template>

<script>
import ChangeTheme from "@/components/layout/ChangeTheme.vue";
import NavbarSimple from "@/components/layout/NavbarSimple.vue";
import StepsViewer from "@/components/utils/StepsViewer.vue";

export default {
    name: "LayoutOnboarding",
    components: {
        NavbarSimple,
        ChangeTheme,
        StepsViewer
    },
    data: () => ({
        currentStep: 0,
        $steps: [
            { name: "Crea Tu tienda" },
            { name: "Carga inventario" },
            { name: "Registra tus ventas" }
        ]
    }),
    computed: {
        currentPath() {
            return this.$route.path;
        }
    },
    watch: {
        currentPath(value) {
            this.validatePath(value);
        }
    },
    created() {
        this.$watch(
            () => this.$route,
            () => {
                document
                    .getElementById("onboarding-container")
                    .scrollIntoView({ behavior: "smooth" });
            },
            {
                deep: true
            }
        );
    },
    mounted() {
        this.validatePath(this.$route.path);
    },
    methods: {
        validatePath(value) {
            const fns = {
                "/onboarding/marketplace": -1,
                "/onboarding/marketplace/store": 0,
                "/onboarding/marketplace/inventories": 1,
                "/onboarding/marketplace/order": 2,
                "/onboarding/marketplace/finish": 3
            };
            const stepNames = {
                "/onboarding/marketplace": "welcome",
                "/onboarding/marketplace/store": "store",
                "/onboarding/marketplace/inventories": "inventories",
                "/onboarding/marketplace/order": "order",
                "/onboarding/marketplace/finish": "finish"
            };

            this.currentStep = fns[value];
            const step = stepNames[value];
            if (step) {
                this.$analytics.trackEvent("onboarding_step_viewed", {
                    onboarding_type: "marketplace",
                    step,
                    step_number: this.currentStep + 2
                });
            }
        }
    }
};
</script>
